import { escapeHtml, fmtDateTime, housePill, propositionLabel, propositionUrl, resultLabel, rollCallUrl, truncate } from "../format.js";

/** Count pills (sim / não / abstenção / obstrução) for a roll-call reference. */
export function renderCountPills(r) {
  return [
    r.votes_yes != null ? `<span class="total-pill total-pill--sim"><strong>${r.votes_yes}</strong> sim</span>` : "",
    r.votes_no != null ? `<span class="total-pill total-pill--nao"><strong>${r.votes_no}</strong> não</span>` : "",
    r.votes_abstain ? `<span class="total-pill total-pill--abstencao"><strong>${r.votes_abstain}</strong> abst.</span>` : "",
    r.votes_obstruction ? `<span class="total-pill total-pill--obstrucao"><strong>${r.votes_obstruction}</strong> obstr.</span>` : "",
  ].join("");
}

/** Compact roll-call card used in lists. */
export function renderRollCallItem(r) {
  const res = resultLabel(r.result);
  const p = r.proposition;
  return `
    <li class="vot-card">
      <div class="vot-card__head">
        ${housePill(r.house)}
        <time datetime="${escapeHtml(r.happened_at)}">${fmtDateTime(r.happened_at)}</time>
        <span class="pill pill--${res.variant}">${escapeHtml(res.text)}</span>
        ${r.is_secret ? `<span class="pill pill--neutral">secreta</span>` : ""}
      </div>
      ${p ? `<p class="status"><a href="${propositionUrl(p)}" data-link>${escapeHtml(propositionLabel(p))}</a> ${p.summary_one_line ? `· <span class="muted">${escapeHtml(truncate(p.summary_one_line, 120))}</span>` : ""}</p>` : ""}
      <p class="vot-card__desc">${escapeHtml(truncate(r.description, 200)) || "—"}</p>
      <div class="totals">${renderCountPills(r)}</div>
      <div class="vot-card__foot"><a class="card__link" href="${rollCallUrl(r)}" data-link>Ver votos por partido →</a></div>
    </li>`;
}
